module.exports = __webpack_public_path__ + "files/b27537a0d0281f98811917d77199bd08.svg";